export const ru = {
    'asc-order': 'Сначала старые',
    'desc-order': 'Сначала новые',
    'order-by-date-label': 'Сортировать по дате'
};
